import { useEffect, useState } from "react";
import Acordion from "../Acordion/Acordion";
import { ContainerBody, Item, SubItem } from "./localStyle";

const Body = ({ global,setGlobal }) => {
  //#region ------ useStates --------
  // const [itemSelected, setItemSelected] = useState(global.dataSelected);
  //#region ------ useStates --------

  //#region ------ funciones --------
  const handleSelect = (id) => {
    if (global.dataSelected.includes(id)) {
      let newList = global.dataSelected.filter(
        (item) => item !== id
      );
      setGlobal({...global, dataSelected: newList })

    } else {
      setGlobal({...global, dataSelected: [...global.dataSelected, id] })
    }
  };
  //#endregion --- funciones --------

  //#region ------ useEffect ------
  // useEffect(()=> {

  // },[global.dataSelected])
  //#endregion --- useEffect ------

  //#region ------ constants ------
  // const lista = global.pagination[global.indexPagination];
  // const itemCursorSelected = lista[global.cursorItemSelected]; 
  //#endregion --- constants ------

  
  return (
    <ContainerBody>
      {
        global.agrupamietoColumn.length > 0 ? <Acordion global={global}  itemSelected={global.dataSelected} handleSelect={handleSelect}/>: 
        (
          global.pagination.length === 0  ? (
            <h1>No hay items</h1>
          ) : (
            global.pagination[global.indexPagination].map((item, key) => {
              return (
                <Item
                  key={key}
                  onClick={() => {
                    handleSelect(item.id);
                  }}
                  selected={global.dataSelected.includes(item.id)}
                >
                  {global.column.map((col, index) => {
                    return (
                      <SubItem
                        key={index}
                        width={
                          global.copyLenCol[index]
                            ? global.copyLenCol[index]
                            : col.width ? col.width : global.copyLenCol["all"]
                        }
                       
                      >
                        {" "}
                        {col.type === "select-boolean" ? (
                          <input type={"checkbox"}  checked={global.dataSelected.includes(item.id)} />
                        ) : (
                         <span>{item[col.name]}</span>
                        )}
                      </SubItem>
                    );
                  })}
                </Item>
              );
            })
          )
        )
      }
    </ContainerBody>
  );
};

export default Body;
